import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Label } from 'web-ui-components/lib/atoms/forms';
import { ContentReveal } from 'web-ui-components/lib/molecules/accordions';
import { ContrastingFormPanel } from 'web-ui-components/lib/molecules/panels';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { Row, Column, FlexColumn, FlexRow } from 'web-ui-components/lib/global/layout';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import SubmissionDate from '../../../bacs/components/BacsPaymentsPage/Form/SubmissionDate';
import PaymentsFileImport from '../../../sharedComponents/PaymentsFileImport';
import styles from '../../../bacs/components/BacsPaymentsPage/BacsPaymentStyles';
import { getDebitRules, getCreditRules } from '../../../utils/paymentsImportUtils';
import pageContent, { contentPropTypes } from '../../../importedPayments/components/bacs/importedPayments.content';
import { dateFormat, TYPE_BACS_CREDIT } from '../../../config';
import { RenderPopper } from '../../../sharedComponents/RenderPopper/RenderPopper';
import withContent from '../../../containers/withContent';

export class FileUploadRevealBlock extends Component {
	constructor(props) {
		super(props);
		this.state = {
			popovers: {},
		};
		this.togglePopover = this.togglePopover.bind(this);
	}

	togglePopover(key) {
		this.setState((state) => ({
			popovers: {
				[key]: !state.popovers[key],
			},
		}));
	}

	render() {
		const {
			type,
			content,
			submissionDate,
			settlementDate,
			showUploadButton,
			handleDateChange,
			handleFileUploadButtonClick,
			handleChooseFileButtonClick,
			faq,
			template,
			maxRecords,
		} = this.props;
		const { popovers } = this.state;

		const isForCredit = type === TYPE_BACS_CREDIT;
		const {
			settlementDateLabel,
			settlementDateDescription,
			settlementDatePopperBody,
			collectionDateLabel,
			collectionDateDescription,
			collectionDatePopperBody,
			submissionDateLabel,
			submissionDateDescription,
			submissionDatePopperBody,
			fileImportText,
			instructionsURLText,
			templateURLText,
			fileUploadButtonText,
		} = content;
		return (
			<div>
				<ContentReveal header="Import payment entries from a file">
					<ContrastingFormPanel>
						<StandardBody>{fileImportText.replace('{maxRecords}', maxRecords)}</StandardBody>
						<StandardBody isFlush>
							<Row className={styles.row__wrapper}>
								<Column md={24}>
									<FlexRow>
										<FlexColumn gutter={2} proportion={1} verticalAlignment="top">
											<div className={styles.field__label}>
												<Label htmlFor="submissionDate">{submissionDateLabel}</Label>
												<RenderPopper
													id="submissionDate"
													content={submissionDatePopperBody}
													isOpen={popovers.submissionDate}
													togglePopover={this.togglePopover}
												/>
											</div>
											<p>{submissionDateDescription}</p>
											<SubmissionDate date={submissionDate} handleDateChange={handleDateChange} />
										</FlexColumn>
										<FlexColumn gutter={2} proportion={1} verticalAlignment="top">
											<div className={styles.field__label}>
												<Label htmlFor="settlementDate">
													{isForCredit ? settlementDateLabel : collectionDateLabel}
												</Label>
												<RenderPopper
													id="settlementDate"
													content={isForCredit ? settlementDatePopperBody : collectionDatePopperBody}
													isOpen={popovers.settlementDate}
													togglePopover={this.togglePopover}
												/>
											</div>
											<p>{isForCredit ? settlementDateDescription : collectionDateDescription}</p>
											<div className={styles.static__field__max__width}>
												{settlementDate ? settlementDate.format(dateFormat) : ''}
											</div>
										</FlexColumn>
									</FlexRow>
								</Column>
							</Row>
							<Row className={styles.row__wrapper}>
								<Column md={24}>
									<FlexRow>
										<FlexColumn gutter={2} proportion={1} verticalAlignment="top">
											{isForCredit && (
												<PaymentsFileImport
													handleChooseFileButtonClick={handleChooseFileButtonClick}
													type={type}
													maxRecords={maxRecords}
													getRules={getCreditRules}
												/>
											)}
											{!isForCredit && (
												<PaymentsFileImport
													handleChooseFileButtonClick={handleChooseFileButtonClick}
													type={type}
													maxRecords={maxRecords}
													{...getDebitRules()}
												/>
											)}
										</FlexColumn>
										{showUploadButton && (
											<FlexColumn gutter={2} proportion={1} verticalAlignment="top">
												<Button
													className="u-margin-bottom-2"
													display="primary"
													width="flush"
													onClick={handleFileUploadButtonClick}
												>
													{fileUploadButtonText}
												</Button>
											</FlexColumn>
										)}
									</FlexRow>
								</Column>
							</Row>
							<Row className={styles.row__wrapper}>
								<Column md={24}>
									<FlexRow>
										<FlexColumn gutter={2} proportion={1} verticalAlignment="top">
											<StandardBody isFlush>
												<WebsiteLink url={faq} linkText={instructionsURLText} willOpenNewWindow />
											</StandardBody>
											<StandardBody isFlush>
												<WebsiteLink url={template} linkText={templateURLText} willOpenNewWindow />
											</StandardBody>
										</FlexColumn>
									</FlexRow>
								</Column>
							</Row>
						</StandardBody>
					</ContrastingFormPanel>
				</ContentReveal>
			</div>
		);
	}
}
FileUploadRevealBlock.default = {
	showUploadButton: false,
};
FileUploadRevealBlock.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	submissionDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
	handleDateChange: PropTypes.func.isRequired,
	handleFileUploadButtonClick: PropTypes.func.isRequired,
	handleChooseFileButtonClick: PropTypes.func.isRequired,
	settlementDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(moment)]),
	showUploadButton: PropTypes.bool.isRequired,
	type: PropTypes.string.isRequired,
	faq: PropTypes.string.isRequired,
	template: PropTypes.string.isRequired,
	maxRecords: PropTypes.number.isRequired,
};

export const contentWrapper = withContent({ content: pageContent })(FileUploadRevealBlock);
